/**
 * Quick Chat Questions
 * คำถามแนะนำเมื่อเริ่มแชท
 */

export const QUESTION_CATEGORIES = {
  PRICE: 'price',
  PRODUCT: 'product',
  AVAILABILITY: 'availability',
  SHIPPING: 'shipping',
  PAYMENT: 'payment',
  CUSTOM: 'custom'
};

/**
 * Default Quick Questions
 */
export const QUICK_QUESTIONS = [
  {
    id: 'price_1',
    question: 'ราคาเท่าไหร่?',
    category: QUESTION_CATEGORIES.PRICE,
    icon: '💰',
    priority: 1,
    conditions: {
      hasPrice: true
    }
  },
  {
    id: 'price_2',
    question: 'มีส่วนลดไหม?',
    category: QUESTION_CATEGORIES.PRICE,
    icon: '🎁',
    priority: 2,
    conditions: {
      hasPrice: true
    }
  },
  {
    id: 'price_3',
    question: 'ราคาส่งเท่าไหร่?',
    category: QUESTION_CATEGORIES.PRICE,
    icon: '📦',
    priority: 3,
    conditions: {
      hasPrice: true,
      hasQuantity: true
    }
  },
  {
    id: 'product_1',
    question: 'ถามรายละเอียดได้ไหม?',
    category: QUESTION_CATEGORIES.PRODUCT,
    icon: '❓',
    priority: 1
  },
  {
    id: 'product_2',
    question: 'มีรูปเพิ่มเติมไหม?',
    category: QUESTION_CATEGORIES.PRODUCT,
    icon: '📸',
    priority: 2,
    conditions: {
      hasImages: true
    }
  },
  {
    id: 'product_3',
    question: 'คุณภาพเป็นยังไง?',
    category: QUESTION_CATEGORIES.PRODUCT,
    icon: '⭐',
    priority: 3
  },
  {
    id: 'availability_1',
    question: 'มีสินค้าไหม?',
    category: QUESTION_CATEGORIES.AVAILABILITY,
    icon: '📦',
    priority: 1
  },
  {
    id: 'availability_2',
    question: 'เหลือเท่าไหร่?',
    category: QUESTION_CATEGORIES.AVAILABILITY,
    icon: '🔢',
    priority: 2,
    conditions: {
      hasQuantity: true
    }
  },
  {
    id: 'availability_3',
    question: 'เมื่อไหร่ส่งได้?',
    category: QUESTION_CATEGORIES.AVAILABILITY,
    icon: '📅',
    priority: 3
  },
  {
    id: 'shipping_1',
    question: 'ส่งยังไง?',
    category: QUESTION_CATEGORIES.SHIPPING,
    icon: '🚚',
    priority: 1
  },
  {
    id: 'shipping_2',
    question: 'ส่งกี่วัน?',
    category: QUESTION_CATEGORIES.SHIPPING,
    icon: '⏱️',
    priority: 2
  },
  {
    id: 'shipping_3',
    question: 'ค่าส่งเท่าไหร่?',
    category: QUESTION_CATEGORIES.SHIPPING,
    icon: '💵',
    priority: 3
  },
  {
    id: 'payment_1',
    question: 'จ่ายยังไง?',
    category: QUESTION_CATEGORIES.PAYMENT,
    icon: '💳',
    priority: 1
  },
  {
    id: 'payment_2',
    question: 'มี COD ไหม?',
    category: QUESTION_CATEGORIES.PAYMENT,
    icon: '📦',
    priority: 2
  },
  {
    id: 'payment_3',
    question: 'โอนได้ไหม?',
    category: QUESTION_CATEGORIES.PAYMENT,
    icon: '🏦',
    priority: 3
  },
  {
    id: 'custom_1',
    question: 'มีคำถามอื่นๆ?',
    category: QUESTION_CATEGORIES.CUSTOM,
    icon: '💬',
    priority: 1
  }
];

/**
 * Get Questions by Product Context
 */
export const getQuestionsByContext = (product, store) => {
  const context = {
    hasPrice: !!product?.price,
    hasQuantity: !!product?.quantity,
    hasImages: product?.images && product.images.length > 0,
    hasShipping: store?.shipping && store.shipping.methods && store.shipping.methods.length > 0,
    hasPayment: store?.payment && store.payment.methods && store.payment.methods.length > 0,
    hasCOD: store?.payment?.cashOnDelivery?.enabled || store?.payment?.methods?.includes('cash_on_delivery'),
    isLowStock: product?.quantity && product.quantity < 10,
    isExpensive: product?.price && product.price > 10000
  };

  return QUICK_QUESTIONS.filter(question => {
    if (!question.conditions) return true;
    
    return Object.keys(question.conditions).every(key => {
      return question.conditions[key] === context[key];
    });
  }).sort((a, b) => a.priority - b.priority).slice(0, 6); // แสดงสูงสุด 6 คำถาม
};

/**
 * Get Questions by Category
 */
export const getQuestionsByCategory = (category) => {
  return QUICK_QUESTIONS.filter(q => q.category === category);
};

/**
 * Format Question for Chat
 */
export const formatQuestionForChat = (question, product) => {
  let formatted = question.question;
  
  // Replace placeholders if needed
  if (product) {
    formatted = formatted.replace('{productName}', product.name || 'สินค้านี้');
    formatted = formatted.replace('{price}', product.price?.toLocaleString() || '');
  }
  
  return formatted;
};







